import { PencilInBoxIcon } from "@8x8/oxygen-icon";
import React, { useCallback, useMemo, useState } from "react";
import { KEY } from "@/react/components/table/useTableMutations";
import DestinationColumnSetterInput from "@/react/features/support-tools/extensions/forwarding-rules/cells/DestinationColumnSetterInput";
import { DESTINATION_TYPES } from "@/react/features/support-tools/extensions/constants";
import { Button } from "@/react/styled";
import InlineBlock from "@/react/features/styled/InlineBlock";
import ColumnSetterInfoContainer from "@/react/features/styled/ColumnSetterInfoContainer";
import ColumnSetterActionContainer from "@/react/features/styled/ColumnSetterActionContainer";

const DestinationColumnSetter = (rule) => (props) => {
  const { table, rows, column } = props;
  const destinationType =
    rows[0]?.original?.forwardingRules[rule]?.destination?.destinationType;
  const rowsHaveSameDestination = useMemo(
    () =>
      rows?.every(
        (row) =>
          row?.original?.forwardingRules[rule]?.destination?.destinationType ===
          destinationType
      ),
    [rows, rule]
  );

  const { schema, updateRows } = table.options.meta;
  const columnId = column.id;
  const firstDestination = rows[0]?.getValue(columnId);
  const [destination, setDestination] = useState(firstDestination);

  const onSet = useCallback(() => {
    const rowKeys = rows.map((row) => row.original[KEY]);
    updateRows(rowKeys, new Map([[columnId, destination]]), schema);
  }, [destination, rows, columnId, updateRows, schema]);

  if (!rowsHaveSameDestination) {
    return (
      <InlineBlock marginLeft={8}>
        Destination type for the selected {rows.length}{" "}
        {rows.length === 1 ? "row" : "rows"} must be the same to perform a bulk
        change.
      </InlineBlock>
    );
  }

  if (destinationType === DESTINATION_TYPES.VOICEMAIL) {
    return (
      <InlineBlock marginLeft={8}>
        Destination for VOICEMAIL cannot be changed.
      </InlineBlock>
    );
  }

  return (
    <>
      <ColumnSetterInfoContainer>
        <PencilInBoxIcon size={18} />
        <InlineBlock marginLeft={8}>
          Set value for{" "}
          <span>
            {rows.length} {rows.length === 1 ? "row" : "rows"}
          </span>
        </InlineBlock>
      </ColumnSetterInfoContainer>
      <ColumnSetterActionContainer>
        <DestinationColumnSetterInput
          destinationType={destinationType}
          rule={rule}
          destination={destination}
          onChange={setDestination}
          errors={[]}
        />
        <Button marginLeft={8} onClick={onSet}>
          Set
        </Button>
      </ColumnSetterActionContainer>
    </>
  );
};

export default DestinationColumnSetter;
